import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 87130 61809"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#343230}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528322909248">
        <path
          d="M37892 59085h11345v-9891c0-754 609-1364 1362-1364h33809v-5717H2724v5717h33806c752 0 1362 611 1362 1364v9891zm12707 2724H36530c-752 0-1358-609-1358-1362v-9891H1362c-752-2-1362-610-1362-1362v-8440c0-753 610-1362 1362-1362h84408c750 0 1360 609 1360 1362v8440c0 752-612 1360-1360 1360l-33809 2v9891c0 753-610 1362-1362 1362z"
          className="fil0"
        />
        <path
          d="M61853 61809H25277c-753 0-1360-609-1360-1362 0-752 606-1362 1360-1362h36576c752 0 1362 610 1362 1362 0 753-610 1362-1362 1362zM2724 39392h81684V2724H2724v36668zm83046 2721H1362c-752-1-1362-611-1362-1359V1363C0 611 610 0 1362 0h84408c750 0 1360 611 1360 1363v39391c0 748-612 1358-1360 1358v1z"
          className="fil0"
        />
        <path
          d="M41575 28872c-349 0-697-133-961-400-532-529-532-1393 0-1926 787-786 1835-1223 2951-1223s2164 437 2951 1223c534 533 534 1397 0 1926-532 533-1392 533-1924 0-275-274-638-425-1027-425-386 0-752 151-1025 425-268 267-617 400-965 400zM49533 24893c-348 0-697-133-962-401-2761-2758-7251-2758-10011 0-531 535-1394 535-1925 0-531-531-531-1391 0-1922 3823-3826 10040-3826 13862 0 531 531 531 1391 0 1922-267 268-615 401-964 401z"
          className="fil0"
        />
        <path
          d="M53513 20915c-350 0-698-135-962-399-2403-2402-5591-3723-8986-3723-3396 0-6585 1321-8984 3721-531 532-1394 532-1924 0-534-532-536-1394 0-1923 2912-2915 6787-4522 10908-4522 4120 0 7995 1607 10910 4522 532 529 532 1391 0 1923-266 266-615 401-962 401z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
